<template>
    <Tracker></Tracker>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Tracker = defineAsyncComponent(() =>
    import("../../components/Logistics/Tracker/Tracker.vue")
);
export default {
    name: "Logistics_Tracker", //The name you are in should not equal the name of the component you are importing.
    components: { Tracker, AuthLayout },
};
</script>